export const environment = {
  useMocks: false,
  useProdMode: true,
  enableDevMode: true,
  enableConsoleLog: true,
  enableComponentGallery: false,
  featureFlags: {
    harmfulEvents: true,
    assignments: true
  },
  recaptchaSiteKey: "6LfFZeIUAAAAABoRlc9uO2zqwpkh5fqGAHZm-qn6",
  allowedReturnUrlOrigins: [],
  apollo: {
    apiUrl: 'https://preview-portal.klobal.cz/graphql',
    subscriptionsUrl: 'wss://preview-portal.klobal.cz/subscriptions',
  },
  rest: {
    apiV2Url: "https://preview-portal.klobal.cz/api/"
  },
  sentry: {
    allow: true,
    dsn: 'https://e38b561a9d52741aa5f5ee3352b0da3e@o4506434096201728.ingest.us.sentry.io/4507922894159872',
    allowReplay: false
  },
  routerTracing: false,
  customMasks: {
    decimalMarker: ',',
    thousandSeparator: ' ',
  },
  environment: 'preview',
  appVersion: 'dev-4453f7f18c429bbc3fdd5446345a274cad1e3d5e'
};
